const layer = {
    title: '<h2><em class="text-gold">Drive</em> times.</h2>',
    intro: '<p>Visiting the Scenic Rim by car takes you through some of the most inspiring parts of Australia, including World Heritage-listed national parks, small-town hidden gems and delicious pit stops.</p>',
    icon: 'car',
    posts: [
        {
            "id": 1,
            "postType": "drive",
            "title": "Tamborine Mountain to Beaudesert",
            "driveTime": 31,
            "distance": 32.8,
            "excerpt": "Distant mountains frame an easy half-hour drive past Wyaralong Dam to the town of Boonah, the Scenic Rim\'s hub for outdoor action and adventure.",
            "lnglat": [
                153.11317,
                -27.90205
            ],
            "route": {
                "start": [
                    153.1845,
                    -27.9284
                ],
                "end": [
                    152.9959,
                    -27.9883
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 1867.539,
                        "distance": 32761.535,
                        "weight": 1691.288
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                153.18449,
                                -27.92841
                            ],
                            [
                                153.18962,
                                -27.92853
                            ],
                            [
                                153.19263,
                                -27.92549
                            ],
                            [
                                153.19287,
                                -27.92317
                            ],
                            [
                                153.18539,
                                -27.9108
                            ],
                            [
                                153.18192,
                                -27.90985
                            ],
                            [
                                153.1857,
                                -27.90955
                            ],
                            [
                                153.18399,
                                -27.9094
                            ],
                            [
                                153.18029,
                                -27.90573
                            ],
                            [
                                153.17885,
                                -27.90047
                            ],
                            [
                                153.17376,
                                -27.90353
                            ],
                            [
                                153.16627,
                                -27.90102
                            ],
                            [
                                153.16485,
                                -27.90412
                            ],
                            [
                                153.16315,
                                -27.90087
                            ],
                            [
                                153.15786,
                                -27.89622
                            ],
                            [
                                153.15365,
                                -27.89369
                            ],
                            [
                                153.14017,
                                -27.88928
                            ],
                            [
                                153.13164,
                                -27.88314
                            ],
                            [
                                153.13042,
                                -27.88081
                            ],
                            [
                                153.11803,
                                -27.89008
                            ],
                            [
                                153.11528,
                                -27.89928
                            ],
                            [
                                153.11317,
                                -27.90205
                            ],
                            [
                                153.09895,
                                -27.9096
                            ],
                            [
                                153.09331,
                                -27.91023
                            ],
                            [
                                153.09008,
                                -27.91194
                            ],
                            [
                                153.08587,
                                -27.91996
                            ],
                            [
                                153.08108,
                                -27.92392
                            ],
                            [
                                153.07972,
                                -27.93392
                            ],
                            [
                                153.0718,
                                -27.9505
                            ],
                            [
                                153.07076,
                                -27.95601
                            ],
                            [
                                153.0617,
                                -27.96758
                            ],
                            [
                                153.06045,
                                -27.97315
                            ],
                            [
                                153.05369,
                                -27.98794
                            ],
                            [
                                153.04497,
                                -27.99057
                            ],
                            [
                                153.03974,
                                -27.99028
                            ],
                            [
                                153.03156,
                                -27.99223
                            ],
                            [
                                153.02486,
                                -27.99163
                            ],
                            [
                                153.01298,
                                -27.99419
                            ],
                            [
                                153.00167,
                                -27.99144
                            ],
                            [
                                152.99582,
                                -27.98835
                            ],
                            [
                                152.99593,
                                -27.9883
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 2,
            "postType": "drive",
            "title": "Beaudesert to Kalbah",
            "driveTime": 34,
            "distance": 44.3,
            "excerpt": "This short drive between two delightful towns leads you down country lanes thorough farmland paddocks. Wind down the windows and enjoy the fresh air.",
            "lnglat": [
                152.81952,
                -27.93259
            ],
            "route": {
                "start": [
                    152.9959,
                    -27.9883
                ],
                "end": [
                    152.6239,
                    -27.9385
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 2036.29,
                        "distance": 44321.434,
                        "weight": 1829.668
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                152.99593,
                                -27.9883
                            ],
                            [
                                152.99594,
                                -27.98835
                            ],
                            [
                                152.99283,
                                -27.99131
                            ],
                            [
                                152.98727,
                                -27.98975
                            ],
                            [
                                152.97687,
                                -27.99174
                            ],
                            [
                                152.96655,
                                -27.98127
                            ],
                            [
                                152.92166,
                                -27.97395
                            ],
                            [
                                152.91707,
                                -27.96961
                            ],
                            [
                                152.91098,
                                -27.96813
                            ],
                            [
                                152.90794,
                                -27.96315
                            ],
                            [
                                152.9017,
                                -27.96128
                            ],
                            [
                                152.88799,
                                -27.96179
                            ],
                            [
                                152.87903,
                                -27.94897
                            ],
                            [
                                152.84459,
                                -27.94087
                            ],
                            [
                                152.83238,
                                -27.94136
                            ],
                            [
                                152.81952,
                                -27.93259
                            ],
                            [
                                152.7924,
                                -27.92791
                            ],
                            [
                                152.7828,
                                -27.93218
                            ],
                            [
                                152.77759,
                                -27.94243
                            ],
                            [
                                152.7547,
                                -27.94823
                            ],
                            [
                                152.75026,
                                -27.95649
                            ],
                            [
                                152.74178,
                                -27.95488
                            ],
                            [
                                152.7363,
                                -27.95664
                            ],
                            [
                                152.72323,
                                -27.95041
                            ],
                            [
                                152.71885,
                                -27.9633
                            ],
                            [
                                152.68505,
                                -27.95714
                            ],
                            [
                                152.68521,
                                -27.94774
                            ],
                            [
                                152.6239,
                                -27.93838
                            ],
                            [
                                152.62388,
                                -27.9385
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 3,
            "postType": "drive",
            "title": "Beaudesert to Boonah",
            "driveTime": 30,
            "distance": 39.6,
            "excerpt": "Distant mountains frame an easy half-hour drive past Wyaralong Dam to the town of Boonah, the Scenic Rim\'s hub for outdoor action and adventure.",
            "lnglat": [
                152.80401,
                -27.93114
            ],
            "route": {
                "start": [
                    152.9959,
                    -27.9883
                ],
                "end": [
                    152.682,
                    -27.9989
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 1797.288,
                        "distance": 39591.434,
                        "weight": 1606.196
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                152.99593,
                                -27.9883
                            ],
                            [
                                152.99594,
                                -27.98835
                            ],
                            [
                                152.99283,
                                -27.99131
                            ],
                            [
                                152.98727,
                                -27.98975
                            ],
                            [
                                152.98247,
                                -27.99162
                            ],
                            [
                                152.97687,
                                -27.99174
                            ],
                            [
                                152.97435,
                                -27.98914
                            ],
                            [
                                152.97106,
                                -27.98812
                            ],
                            [
                                152.96655,
                                -27.98127
                            ],
                            [
                                152.92166,
                                -27.97395
                            ],
                            [
                                152.91707,
                                -27.96961
                            ],
                            [
                                152.91098,
                                -27.96813
                            ],
                            [
                                152.90794,
                                -27.96315
                            ],
                            [
                                152.9017,
                                -27.96128
                            ],
                            [
                                152.89375,
                                -27.96278
                            ],
                            [
                                152.88799,
                                -27.96179
                            ],
                            [
                                152.88393,
                                -27.95863
                            ],
                            [
                                152.88282,
                                -27.95153
                            ],
                            [
                                152.87903,
                                -27.94897
                            ],
                            [
                                152.87117,
                                -27.94665
                            ],
                            [
                                152.86502,
                                -27.94666
                            ],
                            [
                                152.85789,
                                -27.9432
                            ],
                            [
                                152.84459,
                                -27.94087
                            ],
                            [
                                152.83238,
                                -27.94136
                            ],
                            [
                                152.81952,
                                -27.93259
                            ],
                            [
                                152.80401,
                                -27.93114
                            ],
                            [
                                152.7924,
                                -27.92791
                            ],
                            [
                                152.7874,
                                -27.92867
                            ],
                            [
                                152.7828,
                                -27.93218
                            ],
                            [
                                152.78053,
                                -27.93947
                            ],
                            [
                                152.77759,
                                -27.94243
                            ],
                            [
                                152.7547,
                                -27.94823
                            ],
                            [
                                152.75249,
                                -27.95474
                            ],
                            [
                                152.75026,
                                -27.95649
                            ],
                            [
                                152.74178,
                                -27.95488
                            ],
                            [
                                152.7363,
                                -27.95664
                            ],
                            [
                                152.73332,
                                -27.95456
                            ],
                            [
                                152.72911,
                                -27.95396
                            ],
                            [
                                152.72586,
                                -27.95076
                            ],
                            [
                                152.72323,
                                -27.95041
                            ],
                            [
                                152.72053,
                                -27.95543
                            ],
                            [
                                152.71873,
                                -27.96645
                            ],
                            [
                                152.71148,
                                -27.97216
                            ],
                            [
                                152.71027,
                                -27.97683
                            ],
                            [
                                152.70632,
                                -27.98185
                            ],
                            [
                                152.69675,
                                -27.98983
                            ],
                            [
                                152.6828,
                                -27.99383
                            ],
                            [
                                152.68147,
                                -27.99884
                            ],
                            [
                                152.68192,
                                -27.99892
                            ],
                            [
                                152.68202,
                                -27.99887
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 4,
            "postType": "drive",
            "title": "Kalbah to Boonah",
            "driveTime": 10,
            "distance": 11,
            "excerpt": "This short drive between two delightful towns leads you down country lanes thorough farmland paddocks. Wind down the windows and enjoy the fresh air.",
            "lnglat": [
                152.65558,
                -27.97732
            ],
            "route": {
                "start": [
                    152.6239,
                    -27.9385
                ],
                "end": [
                    152.682,
                    -27.9989
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 617.841,
                        "distance": 11005.998,
                        "weight": 576.177
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                152.62388,
                                -27.9385
                            ],
                            [
                                152.61933,
                                -27.96359
                            ],
                            [
                                152.62,
                                -27.96424
                            ],
                            [
                                152.62578,
                                -27.96435
                            ],
                            [
                                152.63292,
                                -27.96628
                            ],
                            [
                                152.63811,
                                -27.96545
                            ],
                            [
                                152.64078,
                                -27.96602
                            ],
                            [
                                152.6436,
                                -27.96834
                            ],
                            [
                                152.64861,
                                -27.97085
                            ],
                            [
                                152.65167,
                                -27.97466
                            ],
                            [
                                152.65558,
                                -27.97732
                            ],
                            [
                                152.66171,
                                -27.98415
                            ],
                            [
                                152.66691,
                                -27.98569
                            ],
                            [
                                152.6705,
                                -27.98799
                            ],
                            [
                                152.67363,
                                -27.98869
                            ],
                            [
                                152.67743,
                                -27.99175
                            ],
                            [
                                152.6825,
                                -27.9936
                            ],
                            [
                                152.68147,
                                -27.99884
                            ],
                            [
                                152.68192,
                                -27.99892
                            ],
                            [
                                152.68202,
                                -27.99887
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 5,
            "postType": "drive",
            "title": "Tamborine Mountain to Canungra",
            "driveTime": 28,
            "distance": 30.3,
            "excerpt": "Wind through lush rainforest and fertile valleys from the mountain oasis of Tamborine Mountain to the charming village of Canungra.",
            "lnglat": [
                153.13042,
                -27.88081
            ],
            "route": {
                "start": [
                    153.1845,
                    -27.9284
                ],
                "end": [
                    153.1647,
                    -28.0172
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 1688.304,
                        "distance": 30342.842,
                        "weight": 1512.846
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                153.18449,
                                -27.92841
                            ],
                            [
                                153.18962,
                                -27.92853
                            ],
                            [
                                153.19263,
                                -27.92549
                            ],
                            [
                                153.19287,
                                -27.92317
                            ],
                            [
                                153.18539,
                                -27.9108
                            ],
                            [
                                153.18192,
                                -27.90985
                            ],
                            [
                                153.1857,
                                -27.90955
                            ],
                            [
                                153.18399,
                                -27.9094
                            ],
                            [
                                153.18029,
                                -27.90573
                            ],
                            [
                                153.17885,
                                -27.90047
                            ],
                            [
                                153.17376,
                                -27.90353
                            ],
                            [
                                153.16627,
                                -27.90102
                            ],
                            [
                                153.16485,
                                -27.90412
                            ],
                            [
                                153.16315,
                                -27.90087
                            ],
                            [
                                153.15786,
                                -27.89622
                            ],
                            [
                                153.15365,
                                -27.89369
                            ],
                            [
                                153.14017,
                                -27.88928
                            ],
                            [
                                153.13164,
                                -27.88314
                            ],
                            [
                                153.13042,
                                -27.88081
                            ],
                            [
                                153.11803,
                                -27.89008
                            ],
                            [
                                153.11528,
                                -27.89928
                            ],
                            [
                                153.11067,
                                -27.90372
                            ],
                            [
                                153.11295,
                                -27.90604
                            ],
                            [
                                153.118,
                                -27.91823
                            ],
                            [
                                153.12313,
                                -27.92534
                            ],
                            [
                                153.13976,
                                -27.94205
                            ],
                            [
                                153.14882,
                                -27.9486
                            ],
                            [
                                153.16337,
                                -27.97199
                            ],
                            [
                                153.16497,
                                -27.97958
                            ],
                            [
                                153.16224,
                                -27.99454
                            ],
                            [
                                153.15631,
                                -28.00065
                            ],
                            [
                                153.15487,
                                -28.00646
                            ],
                            [
                                153.1596,
                                -28.01696
                            ],
                            [
                                153.16466,
                                -28.01714
                            ],
                            [
                                153.16465,
                                -28.01719
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 6,
            "postType": "drive",
            "title": "Boonah to Mount Barney",
            "driveTime": 46,
            "distance": 48.7,
            "excerpt": "Head south from the charming town of Boonah around Maroon Dam to the rugged mountain peaks of Mount Barney.",
            "lnglat": [
                152.74877,
                -28.16822
            ],
            "route": {
                "start": [
                    152.682,
                    -27.9989
                ],
                "end": [
                    152.7431,
                    -28.2395
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 2751.254,
                        "distance": 48747.879,
                        "weight": 2562.546
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                152.68202,
                                -27.99887
                            ],
                            [
                                152.68196,
                                -27.99899
                            ],
                            [
                                152.68007,
                                -28.00791
                            ],
                            [
                                152.6607,
                                -28.03108
                            ],
                            [
                                152.649,
                                -28.05337
                            ],
                            [
                                152.65417,
                                -28.07443
                            ],
                            [
                                152.65318,
                                -28.08607
                            ],
                            [
                                152.64027,
                                -28.10331
                            ],
                            [
                                152.63594,
                                -28.12833
                            ],
                            [
                                152.64122,
                                -28.14536
                            ],
                            [
                                152.65781,
                                -28.16525
                            ],
                            [
                                152.66534,
                                -28.1663
                            ],
                            [
                                152.66845,
                                -28.17058
                            ],
                            [
                                152.67963,
                                -28.16961
                            ],
                            [
                                152.69158,
                                -28.17215
                            ],
                            [
                                152.70715,
                                -28.1668
                            ],
                            [
                                152.71614,
                                -28.17286
                            ],
                            [
                                152.72681,
                                -28.16962
                            ],
                            [
                                152.73878,
                                -28.17209
                            ],
                            [
                                152.74205,
                                -28.16887
                            ],
                            [
                                152.74877,
                                -28.16822
                            ],
                            [
                                152.75144,
                                -28.17245
                            ],
                            [
                                152.7564,
                                -28.17048
                            ],
                            [
                                152.75876,
                                -28.17408
                            ],
                            [
                                152.77395,
                                -28.17956
                            ],
                            [
                                152.77475,
                                -28.19323
                            ],
                            [
                                152.78331,
                                -28.19526
                            ],
                            [
                                152.78576,
                                -28.20057
                            ],
                            [
                                152.79707,
                                -28.20748
                            ],
                            [
                                152.78287,
                                -28.22387
                            ],
                            [
                                152.77641,
                                -28.22643
                            ],
                            [
                                152.76773,
                                -28.22518
                            ],
                            [
                                152.76486,
                                -28.23493
                            ],
                            [
                                152.75847,
                                -28.24236
                            ],
                            [
                                152.75207,
                                -28.24539
                            ],
                            [
                                152.74888,
                                -28.2533
                            ],
                            [
                                152.74467,
                                -28.25257
                            ],
                            [
                                152.74176,
                                -28.24871
                            ],
                            [
                                152.74304,
                                -28.23956
                            ],
                            [
                                152.7431,
                                -28.2395
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 7,
            "postType": "drive",
            "title": "Canungra to Beaudesert",
            "driveTime": 26,
            "distance": 33,
            "excerpt": "Grab a coffee in Canungra and get set for a leisurely drive past equestrian estates, rural homesteads and fertile farmlands, landing in the bustling business hub of Beaudesert.",
            "lnglat": [
                153.08587,
                -27.91996
            ],
            "route": {
                "start": [
                    153.1647,
                    -28.0172
                ],
                "end": [
                    152.9959,
                    -27.9883
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 1559.601,
                        "distance": 33024.387,
                        "weight": 1395.797
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                153.16465,
                                -28.01719
                            ],
                            [
                                153.16466,
                                -28.01714
                            ],
                            [
                                153.1596,
                                -28.01696
                            ],
                            [
                                153.15487,
                                -28.00646
                            ],
                            [
                                153.15631,
                                -28.00065
                            ],
                            [
                                153.16224,
                                -27.99454
                            ],
                            [
                                153.16497,
                                -27.97958
                            ],
                            [
                                153.16337,
                                -27.97199
                            ],
                            [
                                153.14882,
                                -27.9486
                            ],
                            [
                                153.13976,
                                -27.94205
                            ],
                            [
                                153.12313,
                                -27.92534
                            ],
                            [
                                153.118,
                                -27.91823
                            ],
                            [
                                153.11295,
                                -27.90604
                            ],
                            [
                                153.11067,
                                -27.90372
                            ],
                            [
                                153.09895,
                                -27.9096
                            ],
                            [
                                153.09331,
                                -27.91023
                            ],
                            [
                                153.09008,
                                -27.91194
                            ],
                            [
                                153.08587,
                                -27.91996
                            ],
                            [
                                153.08108,
                                -27.92392
                            ],
                            [
                                153.07972,
                                -27.93392
                            ],
                            [
                                153.0718,
                                -27.9505
                            ],
                            [
                                153.07076,
                                -27.95601
                            ],
                            [
                                153.0617,
                                -27.96758
                            ],
                            [
                                153.06045,
                                -27.97315
                            ],
                            [
                                153.05319,
                                -27.98837
                            ],
                            [
                                153.04497,
                                -27.99057
                            ],
                            [
                                153.03974,
                                -27.99028
                            ],
                            [
                                153.03156,
                                -27.99223
                            ],
                            [
                                153.02486,
                                -27.99163
                            ],
                            [
                                153.01298,
                                -27.99419
                            ],
                            [
                                153.00167,
                                -27.99144
                            ],
                            [
                                152.99582,
                                -27.98835
                            ],
                            [
                                152.99593,
                                -27.9883
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 8,
            "postType": "drive",
            "title": "Canungra to The Lost World & Christmas Creek",
            "driveTime": 49,
            "distance": 59.5,
            "excerpt": "Experience the timeless tranquillity of the Lost World, winding through farmland and rainforest-lined valleys to spectacular scenic views.",
            "lnglat": [
                153.00167,
                -27.99144
            ],
            "route": {
                "start": [
                    153.1647,
                    -28.0172
                ],
                "end": [
                    152.9818,
                    -28.1684
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 2950.678,
                        "distance": 59518.945,
                        "weight": 2614.277
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                153.16465,
                                -28.01719
                            ],
                            [
                                153.16466,
                                -28.01714
                            ],
                            [
                                153.1596,
                                -28.01696
                            ],
                            [
                                153.15487,
                                -28.00646
                            ],
                            [
                                153.15631,
                                -28.00065
                            ],
                            [
                                153.16224,
                                -27.99454
                            ],
                            [
                                153.16497,
                                -27.97958
                            ],
                            [
                                153.16337,
                                -27.97199
                            ],
                            [
                                153.14882,
                                -27.9486
                            ],
                            [
                                153.12313,
                                -27.92534
                            ],
                            [
                                153.11067,
                                -27.90372
                            ],
                            [
                                153.09008,
                                -27.91194
                            ],
                            [
                                153.08108,
                                -27.92392
                            ],
                            [
                                153.07972,
                                -27.93392
                            ],
                            [
                                153.07076,
                                -27.95601
                            ],
                            [
                                153.0617,
                                -27.96758
                            ],
                            [
                                153.05319,
                                -27.98837
                            ],
                            [
                                153.01298,
                                -27.99419
                            ],
                            [
                                153.00167,
                                -27.99144
                            ],
                            [
                                152.99582,
                                -27.98835
                            ],
                            [
                                152.96946,
                                -28.02504
                            ],
                            [
                                152.94384,
                                -28.02953
                            ],
                            [
                                152.93665,
                                -28.03758
                            ],
                            [
                                152.93301,
                                -28.04783
                            ],
                            [
                                152.93659,
                                -28.0659
                            ],
                            [
                                152.93599,
                                -28.0865
                            ],
                            [
                                152.93677,
                                -28.09309
                            ],
                            [
                                152.94643,
                                -28.11138
                            ],
                            [
                                152.95408,
                                -28.1179
                            ],
                            [
                                152.96171,
                                -28.13406
                            ],
                            [
                                152.97132,
                                -28.14223
                            ],
                            [
                                152.98974,
                                -28.17202
                            ],
                            [
                                152.98629,
                                -28.1733
                            ],
                            [
                                152.98186,
                                -28.16826
                            ],
                            [
                                152.98175,
                                -28.1683
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 9,
            "postType": "drive",
            "title": "The Lost World & Christmas Creek to Mount Barney",
            "driveTime": 34,
            "distance": 34.2,
            "excerpt": "Venture off the beaten track during this epic journey from the peaceful valleys of the Lost World through the historic town of Rathdowney to the majestic Mount Barney.",
            "lnglat": [
                152.8309,
                -28.21558
            ],
            "route": {
                "start": [
                    152.9818,
                    -28.1684
                ],
                "end": [
                    152.7431,
                    -28.2395
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 2061.14,
                        "distance": 34213.754,
                        "weight": 1917.507
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                152.98175,
                                -28.1683
                            ],
                            [
                                152.97068,
                                -28.17315
                            ],
                            [
                                152.96392,
                                -28.17289
                            ],
                            [
                                152.95657,
                                -28.17497
                            ],
                            [
                                152.94738,
                                -28.17931
                            ],
                            [
                                152.92275,
                                -28.17172
                            ],
                            [
                                152.90902,
                                -28.16931
                            ],
                            [
                                152.90359,
                                -28.17423
                            ],
                            [
                                152.90271,
                                -28.1707
                            ],
                            [
                                152.89998,
                                -28.1684
                            ],
                            [
                                152.902,
                                -28.16586
                            ],
                            [
                                152.88995,
                                -28.17023
                            ],
                            [
                                152.87839,
                                -28.18188
                            ],
                            [
                                152.87379,
                                -28.19493
                            ],
                            [
                                152.87011,
                                -28.2005
                            ],
                            [
                                152.86655,
                                -28.20256
                            ],
                            [
                                152.86443,
                                -28.21091
                            ],
                            [
                                152.85836,
                                -28.21893
                            ],
                            [
                                152.84921,
                                -28.21628
                            ],
                            [
                                152.84374,
                                -28.21716
                            ],
                            [
                                152.8369,
                                -28.22042
                            ],
                            [
                                152.8309,
                                -28.21558
                            ],
                            [
                                152.82837,
                                -28.21517
                            ],
                            [
                                152.82511,
                                -28.21842
                            ],
                            [
                                152.82256,
                                -28.21904
                            ],
                            [
                                152.80686,
                                -28.20972
                            ],
                            [
                                152.79707,
                                -28.20748
                            ],
                            [
                                152.79343,
                                -28.20975
                            ],
                            [
                                152.78818,
                                -28.21893
                            ],
                            [
                                152.78287,
                                -28.22387
                            ],
                            [
                                152.77641,
                                -28.22643
                            ],
                            [
                                152.76773,
                                -28.22518
                            ],
                            [
                                152.76486,
                                -28.23493
                            ],
                            [
                                152.75847,
                                -28.24236
                            ],
                            [
                                152.75207,
                                -28.24539
                            ],
                            [
                                152.75126,
                                -28.25003
                            ],
                            [
                                152.74888,
                                -28.2533
                            ],
                            [
                                152.74467,
                                -28.25257
                            ],
                            [
                                152.74176,
                                -28.24871
                            ],
                            [
                                152.74304,
                                -28.23956
                            ],
                            [
                                152.7431,
                                -28.2395
                            ]
                        ]
                    }
                }
            }
        },
        {
            "id": 10,
            "postType": "drive",
            "title": "Beaudesert to Mount Barney",
            "driveTime": 45,
            "distance": 49.3,
            "excerpt": "Take an easy drive south from Beaudesert to historic Rathdowney, a great place for a pit stop before your journey to Mount Barney, one of Queensland\'s most impressive peaks.",
            "lnglat": [
                152.85836,
                -28.21893
            ],
            "route": {
                "start": [
                    152.9959,
                    -27.9883
                ],
                "end": [
                    152.7431,
                    -28.2395
                ],
                "path": {
                    "type": "Feature",
                    "properties": {
                        "duration": 2699.049,
                        "distance": 49298.32,
                        "weight": 2466.041
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [
                            [
                                152.99593,
                                -27.9883
                            ],
                            [
                                152.99594,
                                -27.98835
                            ],
                            [
                                152.96946,
                                -28.02504
                            ],
                            [
                                152.94384,
                                -28.02953
                            ],
                            [
                                152.93665,
                                -28.03758
                            ],
                            [
                                152.93301,
                                -28.04783
                            ],
                            [
                                152.93659,
                                -28.0659
                            ],
                            [
                                152.93595,
                                -28.08678
                            ],
                            [
                                152.92009,
                                -28.09489
                            ],
                            [
                                152.91486,
                                -28.10472
                            ],
                            [
                                152.91786,
                                -28.13636
                            ],
                            [
                                152.91371,
                                -28.15238
                            ],
                            [
                                152.90664,
                                -28.16233
                            ],
                            [
                                152.88995,
                                -28.17023
                            ],
                            [
                                152.87839,
                                -28.18188
                            ],
                            [
                                152.87379,
                                -28.19493
                            ],
                            [
                                152.86655,
                                -28.20256
                            ],
                            [
                                152.86443,
                                -28.21091
                            ],
                            [
                                152.85836,
                                -28.21893
                            ],
                            [
                                152.84921,
                                -28.21628
                            ],
                            [
                                152.8369,
                                -28.22042
                            ],
                            [
                                152.82837,
                                -28.21517
                            ],
                            [
                                152.82256,
                                -28.21904
                            ],
                            [
                                152.80686,
                                -28.20972
                            ],
                            [
                                152.79707,
                                -28.20748
                            ],
                            [
                                152.78287,
                                -28.22387
                            ],
                            [
                                152.77641,
                                -28.22643
                            ],
                            [
                                152.76773,
                                -28.22518
                            ],
                            [
                                152.76486,
                                -28.23493
                            ],
                            [
                                152.75847,
                                -28.24236
                            ],
                            [
                                152.75207,
                                -28.24539
                            ],
                            [
                                152.74888,
                                -28.2533
                            ],
                            [
                                152.74467,
                                -28.25257
                            ],
                            [
                                152.74176,
                                -28.24871
                            ],
                            [
                                152.74304,
                                -28.23956
                            ],
                            [
                                152.7431,
                                -28.2395
                            ]
                        ]
                    }
                }
            }
        }
    ],
};
export default layer;
